import styles from './congratulations.module.scss'
import rocket from '../images/rocket.svg';
import plus from 'shared/images/logo-investor-plus.png';
import { LinkButton, SubscriptionLogo } from 'shared/ui-kit';
import { useContext } from 'react';
import { SiteResolution, SiteResolutionContext } from 'shared/mechanics/site-resolution';
import { adjustImageUrl } from 'helpers';

export const SubscriptionCompleteCongratulations = () => {
	const siteResolution = useContext(SiteResolutionContext);
	return (
		<div className={styles.container}>
			{
				siteResolution == SiteResolution.Desktop
					? (<div><img src={adjustImageUrl(rocket)}></img></div>)
					: null
			}
			<div className={styles.block}>
				<h2 className={styles.header}>Поздравляем!</h2>
				<p className={styles.text}>
					Теперь вы <SubscriptionLogo />
				</p>
				
					<LinkButton title="Скринер" href="/screener" className={styles.link} />
				
					<LinkButton title="Карты" href="/map" className={styles.link} />
				
			</div>
		</div>
	);
}